import { render, staticRenderFns } from "./traineeQuestions.vue?vue&type=template&id=a0bda52e&scoped=true"
import script from "./traineeQuestions.vue?vue&type=script&lang=js"
export * from "./traineeQuestions.vue?vue&type=script&lang=js"
import style0 from "./traineeQuestions.vue?vue&type=style&index=0&id=a0bda52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bda52e",
  null
  
)

export default component.exports